module.exports = __webpack_public_path__ + "static/media/carta_63.70d00a5f.jpg";